import { useQuery } from "react-query";

import { getCurrency } from "../../../../../MyApi/sb/currency";

import Select from "react-select"
import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";


import classes from "./addCountry.module.css";

const AddCountry = ({
  setCountryName,
  setCurrencyId,
  setCurrencyCode,
  setPhoneCode,
  countryName, currencyCode,  phoneCode ,
  selectedCurrency ,setSelectedCurrency
}) => {
const {data , isLoading} = useQuery("getCurrency",getCurrency )
const currencies = data?.data
  const Earth = icons.Earth;
  const Dollar = icons.Dollar
  const Phone = icons.phone

  const handleNameChange = (e) => {
    setCountryName(e.target.value);
  };
  const handlePhoneCodeChange = (e) => {
    setPhoneCode(e.target.value);
  };
  const handleCurrenyChange = (selectedOption) => {
   const currencyId = selectedOption ? selectedOption.id :null
    setCurrencyId(currencyId);

  };
  const handleCodeChange = (e) => {
    setCurrencyCode(e.target.value);
  };
  if(isLoading){
    return <LoadingSpinner/>
  }
  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات الدولة</h5>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الدولة</label>
          <div className={classes.iconInput}>
            <Earth />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم الدولة"
            value={countryName}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">رمز الهاتف الدولي</label>
          <div className={classes.iconInput}>
            <Phone />
          </div>
          <input
            type="text"
            placeholder="ادخل رمز الهاتف الدولي"
            value={phoneCode}
            onChange={handlePhoneCodeChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">العملة</label>
     
          {!data ? <div>no data avalible</div>:
          <Select
            onChange={handleCurrenyChange}
            options={currencies}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            classNames="form-control"
           />}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">كود الدولة</label>
          <div className={classes.iconInput}>
            <Dollar />
          </div>
          <input
            type="text"
            placeholder="ادخل  كود العملة"
            value={currencyCode}
            onChange={handleCodeChange}
            className={classes.inputCustom}
          />
        </div>
      </div>
    </div>
  );
};

export default AddCountry;
